module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_6.48db3872.png";